var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";
import { omit } from "lodash";
import { Mutation as MutationComponent } from "@irati/utils/services/apollo";
export var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ArchiveCompanyValue($companyValue: CompanyValueInput!, $tenantId: String!) {\n    archiveCompanyValue(companyValue: $companyValue, tenantId: $tenantId) {\n      uuid\n    }\n  }\n"], ["\n  mutation ArchiveCompanyValue($companyValue: CompanyValueInput!, $tenantId: String!) {\n    archiveCompanyValue(companyValue: $companyValue, tenantId: $tenantId) {\n      uuid\n    }\n  }\n"])));
function parseCompanyValue(companyValue) {
    return omit(companyValue, ["__typename"]);
}
var TypedMutation = /** @class */ (function (_super) {
    __extends(TypedMutation, _super);
    function TypedMutation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TypedMutation;
}(Mutation));
var ArchiveCompanyValueMutation = /** @class */ (function (_super) {
    __extends(ArchiveCompanyValueMutation, _super);
    function ArchiveCompanyValueMutation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArchiveCompanyValueMutation.prototype.render = function () {
        var _a = this.props, children = _a.children, companyValue = _a.companyValue, tenantId = _a.tenantId;
        return (React.createElement(MutationComponent, __assign({ mutation: mutation, MutationComponent: TypedMutation }, this.props), function (mutate, apolloState) {
            return children(function (args) {
                return mutate(__assign({ variables: {
                        companyValue: parseCompanyValue(companyValue),
                        tenantId: tenantId
                    }, refetchQueries: ["CompanyValues"], awaitRefetchQueries: true }, args));
            }, apolloState);
        }));
    };
    return ArchiveCompanyValueMutation;
}(PureComponent));
export default ArchiveCompanyValueMutation;
var templateObject_1;
